export default __webpack_public_path__ + "static/media/grafema_capitolio_07.772226aa.jpg";